import { PagingQuery } from 'tea-component';
import { SortByItemType } from '@/pages/intelligence/components/TableComponents/components/SortBy';
import {
  TableSelectStatusType,
  TableSelectionType,
} from '@/pages/intelligence/components/TableComponents/components/TableCheckbox';

export type nullStr = undefined | string;
export type numStr = number | string;

export interface FilterTypeCfgType {
  [key: string]: string[];
}

export interface RanksResponse<E = any> {
  total: number;
  list: E[];
  req: {
    start_date: string;
    end_date: string;
    [key: string]: any;
  };
  error?: {
    code?: number;
    msg?: string;
  };
}

export interface TrendsResponse<E1 = any, E2 = any> {
  list: E1[];
  barList: E2[];
}

export interface SortedByTargetProps {
  sortedByValue?: string;
  text?: string;
  isNew?: boolean;
  nameTextMap?: any;
  auType?: any;
  timeType?: any;
  sortedData?: any;
  order?: any;
  icon?: any;
  style?: any;
  sortByKey?: any;
  dataSourcesColumns?: any;
}
export interface PageSortAttrType {
  tablePageIndex: number;
  tablePageSize: number;
  currentSortValue: 'desc' | 'asc';
  currentSortMetric?: string;
  currentOrderSource?: string;
  currentRatioType?: number;
  currentOrderDevice?: string;
  dataSources?: any;
}

export interface TopRPDRank {
  unifiedId: string;
  gameName: string;
  gameOhterName: string;
  gameIcon: string;
  gameMarketName: string;
  gameFullMarketName: string;
  gameCompany: string;
  rank: string | number;
  rpd: string | number;
  revenue: string | number;
  download: string | number;
  releaseDate: string;
  mainGenre: string;
  subgenre: string;
}

export interface TopchartTableProps {
  className?: string;
  loading?: boolean;
  /** 列表数据 */
  records: any[];
  /** 列表总条目 */
  tableTotal: number;
  /** 列表全选值（6个） */
  tableSelectionAll: TableSelectionType[];
  /** 勾选的列表（最多10个） */
  tableSelection: TableSelectionType[];
  /** 分页与排序值 */
  pageSortAttr: PageSortAttrType;
  onTableSortChage: (query: SortByItemType) => void;
  onTablePagingChange: (query: PagingQuery) => void;
  onTableCheckGame: (selectList: TableSelectionType[], checkStaus: TableSelectStatusType) => void;
  entityType?: string;
}

export interface LineChartData {
  seriesData: any[];
  xAxisData: any[];
  yAxisFormatter: Function;
  tooltipFormatter?: Function;
  createLegendsCustomMade?: Function;
  lineLegendsCustomMade?: any;
}

export interface swiperParamsInfo {
  // 是否展示左右箭头
  showArrows?: boolean;
  // 是否展示指示器
  showIndicators?: boolean;
  // 是否循环
  infiniteLoop?: boolean;
  // 是否自动播放
  autoPlay?: boolean;
  // 是否拖拽滑动
  emulateTouch?: boolean;
  // 是否展示右上角状态
  showStatus?: boolean;
  // 鼠标放上去是否停止播放
  stopOnHover?: boolean;
  // 是否展示轮播缩放展示图
  showThumbs?: boolean;
  // 是否使用键盘左右按钮滑动
  useKeyboardArrows?: boolean;
  // 是否刷新
  swipeable?: boolean;
  // 动态高度
  dynamicHeight?: boolean;
}

export enum RenderType {
  VALUE_AND_RATIO, // 默认 值+环比
  VALUE_AND_RATIO_NOPOINT, // 默认 值+环比(环比没有小数据点，小于1大于0才有)
  GROWTH_ONLY, // 仅百分比
  GROWTH_ONLY_PERCENTVALUE, // 仅百分比，且不用*100，仅加%
  VALUE_ONLY, // 仅数值
  VALUE_ONLY_NO_BMK_UNIT, // 仅数值，并且不显示 BMK 单位
  GROWTH_AND_RATIO, // 百分比+环比
  RANK_AND_RATIO, // 名次和名次环比
  TEXT, // 文本
  PRICE, // 价格，0展示Free
  STEAM_PRICE, // 特殊类型， 带可视化的steam price
  COUNTRY_CHART,
  RATINGS, // 评分
  TABLE_BAR_CHART, // 柱状堆叠图-Demographics
  TABLE_SHOW_IMAGE, // 图表展示前4图片
  METACRITIC_SCORE, // 评分指标
  PC_CONSOLE_COMPARE, // PC-Console对比
  TAGS, // SteamTags、GameMode 展示 tag 标签
  RANK_AND_RATIO_STORERANK_DETAIL, // 名次和名次环比,storerank_detail_rank_trend
}
